import { render, staticRenderFns } from "./StaffGuru.vue?vue&type=template&id=33a18077&scoped=true&"
import script from "./StaffGuru.vue?vue&type=script&lang=js&"
export * from "./StaffGuru.vue?vue&type=script&lang=js&"
import style0 from "./StaffGuru.vue?vue&type=style&index=0&id=33a18077&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a18077",
  null
  
)

export default component.exports